<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование публикации" : "Добавление публикации"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs6)
          v-select(
            v-if='attributes'
            :error='errors.has("sub_type")'
            :error-messages='errors.first("sub_type")'
            :items='attributes.sub_type'
            item-text='name'
            item-value='id'
            v-model='model.sub_type'
            label='Тип контента'
          )
        v-flex(xs6)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='model.name'
            label='Название'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("annotation")'
            :error-messages='errors.first("annotation")'
            v-model='model.annotation'
            label='Комментарий'
            counter
          )
        v-flex(xs6)
          v-text-field(
            :error='errors.has("author")'
            :error-messages='errors.first("author")'
            v-model='model.author'
            label='Автор'
          )
        v-flex(xs6)
          v-text-field(
            :error='errors.has("link")'
            :error-messages='errors.first("link")'
            v-model='model.link'
            label='Внешняя ссылка'
          )
        v-flex(xs6)
          s-auto-image-upload(
            v-model='model.picture'
            :src='model.picture_url'
            :parseResponse='r => r.hash'
            label='Картинка'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import http from '@/http'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    model: {},
    attributes: {}
  }),

  async created() {
    this.fetchAttributes()
    if (this.id===undefined) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id.toString() })
      this.model = response.data
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/socialgallery/attributes')
        this.attributes = res.data
        if (!this.model.sub_type)
          this.setDefaultSubtype()
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Content.SocialGallery.List' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    setDefaultSubtype () {
      this.model.sub_type = this.attributes.sub_type.find((el)=> el.default===true).id
    },

    _parseResponse(response) {
      try {
        return JSON.parse(response)
      } catch (e) {
        throw e
      }
    },

    vError(index, key) {
      if (this.bErrors[index] && this.bErrors[index][key]) {
        return this.bErrors[index][key]
      }
    },

    ...mapActions('content/socialgallery', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    ...mapGetters('content/socialgallery', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
